const locale = {
  placeholder: 'समय का चयन करें',
};

export default locale;
